// import axios from "axios";
// import FormData from "form-data";
// import { ReadStream } from "fs";

// export async function pinToIPFS(
//   // readStreams: ReadStream | ReadStream[]
//   readStreams: ReadableStream | ReadableStream[]
// ): Promise<any> {
//   const url = "https://api.pinata.cloud/pinning/pinFileToIPFS";
//   const data = new FormData();

//   const JWT = `Bearer ${process.env.REACT_APP_PINATA_JWT_TOKEN}`;
//   if (Array.isArray(readStreams)) {
//     for (let i = 0; i < readStreams.length; i++) {
//       data.append(`file${i}`, readStreams[i]);
//     }
//   } else {
//     data.append("file", readStreams);
//   }

//   // const boundary = data.getBoundary();

//   // const response = await axios.post(url, data, {
//   //   headers: {
//   //     "Content-Type": `multipart/form-data;`,
//   //     Authorization: JWT,
//   //   },
//   // });

//   // return Array.isArray(readStreams)
//   //   ? response.data.map((item: any) => item)
//   //   : [response.data];

//   const options = {
//     method: "POST",
//     url: url,
//     headers: {
//       accept: "application/json",
//       "content-type":
//         "multipart/form-data; boundary=---011000010111000001101001",
//       authorization: JWT,
//     },
//     data: "[form]",
//   };

//   axios
//     .request(options)
//     .then(function (response) {
//       console.log(response.data);
//       return response.data;
//     })
//     .catch(function (error) {
//       console.error(error);
//     });
// }

// Single Image Upload
import { useState } from "react";
import axios from "axios";
import { base64StringToFile } from "../utils/stringToBytes32";
const JWT = `Bearer ${process.env.REACT_APP_PINATA_JWT_TOKEN}`;

export const handleIPFSUpload = async (images: File) => {
  const formData = new FormData();

  // Array.from(images).forEach((image) => {
  //   formData.append("image", image);
  // });
  // images.map((image) => {
  //   formData.append("image", image);
  // });

  formData.append("file", images);

  const metadata = JSON.stringify({
    name: "Image name",
  });
  formData.append("pinataMetadata", metadata);

  const options = JSON.stringify({
    cidVersion: 0,
  });
  formData.append("pinataOptions", options);
  // console.log(formData);

  try {
    const res = await axios.post(
      "https://api.pinata.cloud/pinning/pinFileToIPFS",
      formData,
      {
        maxBodyLength: Infinity,
        headers: {
          //@ts-ignore
          "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
          Authorization: JWT,
        },
      }
    );
    return res?.data;
  } catch (error) {
    return error;
  }
};

export async function uploadBase64ToPinata(base64String: string) {
  try {
    const file = await base64StringToFile(base64String);

    const data = new FormData();
    data.append("file", file);

    const metadata = JSON.stringify({
      name: "Image name",
    });
    data.append("pinataMetadata", metadata);

    const options = JSON.stringify({
      cidVersion: 0,
    });
    data.append("pinataOptions", options);

    // console.log(data);

    // const res = await axios.post(
    //   "https://api.pinata.cloud/pinning/pinFileToIPFS",
    //   {
    //     headers: {
    //       Authorization: JWT,
    //     },
    //     body: data,
    //   }
    // );

    const res = await axios.post(
      "https://api.pinata.cloud/pinning/pinFileToIPFS",
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          //@ts-ignore
          "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
          Authorization: JWT,
        },
      }
    );
    return res?.data;
  } catch (error) {
    return error;
  }
}
